import React  from 'react';
import cn from 'clsx';
import { modalContentAction } from './modal-styles';

type ModalContentActionProps = {
  className?: string;
  children: React.ReactNode;
}

export const ModalContentAction: React.FC<ModalContentActionProps> = ({ className, children }) => (
  <div className={cn(modalContentAction, className)}>
    {children}
  </div>
);
